import {
  Avatar,
  Box,
  Flex,
  Heading,
  SimpleGrid,
  Skeleton,
  Text,
  useColorModeValue,
  VStack,
} from '@chakra-ui/react';
/* eslint-disable import/no-duplicates */
import { format, parseISO } from 'date-fns';
import { ptBR } from 'date-fns/locale';
import React from 'react';
import {
  LuBriefcase,
  LuCircleDot,
  LuIdCard,
  LuMail,
  LuMapPin,
  LuPhone,
} from 'react-icons/lu';
import { Checkbox } from '../../components/shared/Checkbox';
import DefaultPage from '../../components/shared/DefaultPage';
import { Input } from '../../components/shared/Input';
import { usePerfil } from '../../services/hooks/usePerfil';
import formatValue from '../../utils/formatValue';

const Perfil: React.FC<any> = () => {
  // estilos
  const color = useColorModeValue('#1A202C', 'white');
  const bg = useColorModeValue('white', 'gray.800');

  // dados
  const { data, isLoading } = usePerfil();

  const Status = {
    1: 'Ativo',
    2: 'Inativo',
    3: 'Aguardando Confirmação',
  };

  if (isLoading) {
    return (
      <DefaultPage>
        <Flex mt="12" mx="4" justify="space-between">
          <Flex align="center">
            <Avatar />
            <Skeleton ml="2" h="30px" w="150px" />
          </Flex>
        </Flex>
        <Flex
          mt="2"
          borderWidth="1px"
          bg={bg}
          rounded="2xl"
          p="4"
          flexDir="column"
        >
          <SimpleGrid
            templateColumns={['1fr', '1fr', '3fr 1fr']}
            gridRowGap={4}
            gap={4}
          >
            <Skeleton h="466px" />
            <Flex h="100%" w="100%" flexDir="column" gridRowGap={4}>
              <Skeleton h="226px" />
              <Skeleton h="226px" />
            </Flex>
          </SimpleGrid>
        </Flex>
      </DefaultPage>
    );
  }

  return (
    <DefaultPage>
      <Flex mt="12" mx="4" justify="space-between">
        <Flex align="center">
          <Avatar name={data?.usuario.nome} size="md" />
          <Flex ml="2" flexDir="column">
            <Heading fontSize="2xl">{data?.usuario.nome}</Heading>
            <Heading fontSize="sm" mt="1">
              Parceiro desde:{' '}
              {data?.usuario?.created_at
                ? format(parseISO(data.usuario.created_at), 'dd/MM/yyyy', {
                    locale: ptBR,
                  })
                : '--'}
            </Heading>
          </Flex>
        </Flex>
      </Flex>

      <Flex
        mt="2"
        borderWidth="1px"
        bg={bg}
        rounded="2xl"
        p="4"
        flexDir="column"
      >
        <Text color={color}>Seus dados:</Text>
        <SimpleGrid
          templateColumns={['1fr', '1fr', '3fr 1fr']}
          w="100%"
          mt="4"
          mb="4"
        >
          <Flex w="100%" flexDir="column" mt="1" gridRowGap="4">
            <SimpleGrid
              templateColumns={['1fr', '1fr', '1fr 1fr 1fr']}
              columnGap="4"
            >
              <Input
                value={data?.usuario.email}
                leftIcon={LuMail}
                label="email"
                name="email"
              />
              <Input
                value={data?.usuario.telefone}
                leftIcon={LuPhone}
                label="telefone"
                name="telefone"
                mask="(00) 00000-0000"
              />
              <Input
                value={Status[data?.usuario.status]}
                leftIcon={LuCircleDot}
                label="status"
                name="status"
              />
              <Input
                value={data?.usuario.cpf}
                leftIcon={LuIdCard}
                mask="000.000.000-00"
                label="CPF"
                name="cpf"
              />
              <Input
                value={data?.usuario.cnpj}
                leftIcon={LuBriefcase}
                mask="00.000.000/0000-00"
                label="CNPJ"
                name="cnpj"
              />
            </SimpleGrid>
            <SimpleGrid
              templateColumns={['1fr', '1fr', '1fr 1fr 1fr']}
              columnGap="4"
            >
              <Input
                value={data?.endereco.cep}
                leftIcon={LuMapPin}
                mask="00000-000"
                label="cep"
                name="cep"
              />
              <Input
                value={data?.endereco.uf}
                leftIcon={LuMapPin}
                label="UF"
                name="uf"
                //
              />
              <Input
                value={data?.endereco.cep}
                leftIcon={LuMapPin}
                label="cidade"
                name="cep"
              />
              <Input
                value={data?.endereco.bairro}
                leftIcon={LuMapPin}
                label="bairro"
                name="bairro"
              />
              <Input
                value={data?.endereco.numero}
                leftIcon={LuMapPin}
                label="numero"
                name="numero"
              />
              <Input
                value={data?.endereco.logradouro}
                leftIcon={LuMapPin}
                label="logradouro"
                name="logradouro"
              />
            </SimpleGrid>
            <Input
              value={data?.endereco.complemento}
              leftIcon={LuMapPin}
              label="complemento"
              name="complemento"
            />
          </Flex>
          <VStack align="flex-start" ml="4" spacing="2">
            <Box w="100%">
              <Flex
                align="center"
                flexDir="column"
                borderWidth="1px"
                roundedTop="md"
                w="100%"
              >
                <Flex pt="1" px="2" w="100%">
                  <Text>Custo Certificado:</Text>
                </Flex>
                <Flex
                  align="center"
                  justify="flex-start"
                  w="100%"
                  borderTopWidth="1px"
                  py="1"
                >
                  <Text color={color} pl="4">
                    {formatValue(data?.usuario.comissao_pai ?? 0)}
                  </Text>
                </Flex>
              </Flex>
              <Flex
                align="center"
                flexDir="column"
                borderWidth="1px"
                w="100%"
                //
              >
                <Flex pt="1" px="2" w="100%">
                  <Text>Comissão:</Text>
                </Flex>
                <Flex
                  align="center"
                  justify="flex-start"
                  w="100%"
                  borderTopWidth="1px"
                  py="1"
                >
                  <Text color={color} pl="4">
                    {formatValue(data?.usuario.comissao_certificado ?? 0)}
                  </Text>
                </Flex>
              </Flex>
              <Flex
                align="center"
                flexDir="column"
                borderWidth="1px"
                roundedBottom="md"
                w="100%"
              >
                <Flex pt="1" px="2" w="100%">
                  <Text>Valor de venda do certificado:</Text>
                </Flex>
                <Flex
                  align="center"
                  justify="flex-start"
                  w="100%"
                  borderTopWidth="1px"
                  py="1"
                >
                  <Text
                    bgGradient="linear(to-b, green.300, green.500)"
                    bgClip="text"
                    fontWeight="bold"
                    pl="4"
                  >
                    {formatValue(
                      Number(data?.usuario.comissao_pai ?? 0) +
                        Number(data?.usuario.comissao_certificado ?? 0),
                    )}
                  </Text>
                </Flex>
              </Flex>
            </Box>
            <Text>Permissões:</Text>
            <Box
              w="100%"
              borderWidth="1px"
              mt="2"
              maxH="250px"
              h="250px"
              rounded="xl"
              pl="2"
              overflowY="auto"
            >
              {data?.permissoes?.map(item => {
                return (
                  <Flex p="2">
                    <Checkbox
                      label={item}
                      name={item}
                      isChecked
                      //
                    />
                  </Flex>
                );
              })}
            </Box>
          </VStack>
        </SimpleGrid>
      </Flex>
    </DefaultPage>
  );
};

export default Perfil;
